/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiQueryTemplate } from './ApiQueryTemplate';
import {
    ApiQueryTemplateFromJSON,
    ApiQueryTemplateFromJSONTyped,
    ApiQueryTemplateToJSON,
    ApiQueryTemplateToJSONTyped,
} from './ApiQueryTemplate';

/**
 * 
 * @export
 * @interface QueryTemplatePage
 */
export interface QueryTemplatePage {
    /**
     * 
     * @type {number}
     * @memberof QueryTemplatePage
     */
    number: number;
    /**
     * 
     * @type {number}
     * @memberof QueryTemplatePage
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof QueryTemplatePage
     */
    total: number;
    /**
     * 
     * @type {Array<ApiQueryTemplate>}
     * @memberof QueryTemplatePage
     */
    content: Array<ApiQueryTemplate>;
}

/**
 * Check if a given object implements the QueryTemplatePage interface.
 */
export function instanceOfQueryTemplatePage(value: object): value is QueryTemplatePage {
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function QueryTemplatePageFromJSON(json: any): QueryTemplatePage {
    return QueryTemplatePageFromJSONTyped(json, false);
}

export function QueryTemplatePageFromJSONTyped(json: any, ignoreDiscriminator: boolean): QueryTemplatePage {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'],
        'size': json['size'],
        'total': json['total'],
        'content': ((json['content'] as Array<any>).map(ApiQueryTemplateFromJSON)),
    };
}

export function QueryTemplatePageToJSON(json: any): QueryTemplatePage {
    return QueryTemplatePageToJSONTyped(json, false);
}

export function QueryTemplatePageToJSONTyped(value?: QueryTemplatePage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'total': value['total'],
        'content': ((value['content'] as Array<any>).map(ApiQueryTemplateToJSON)),
    };
}

